// src/pages/Home.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import BottomNav from "../components/BottomNav";
import AddBookModal from "../components/AddBookModal";
import BookCard from "../components/BookCard";
import { useAuth } from "../context/AuthContext";
import "./Home.css";

const Home = () => {
  const [books, setBooks] = useState([]);
  const [requests, setRequests] = useState(0); // NEW
  const [search, setSearch] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

  console.log("showAddModal:", showAddModal);


  const fetchBooks = async () => {
    try {
      const res = await api.get("/books");
      setBooks(res.data.books || []);
    } catch (err) {
      console.error(err);
      setBooks([]);
    } finally {
      setLoading(false);
    }
  };

  // 🔥 Fetch pending requests count
  const fetchRequests = async () => {
    try {
      const res = await api.get("/books/requests");
      setRequests(res.data.requests?.length || 0);
    } catch (err) {
      console.error("Request fetch error:", err);
      setRequests(0);
    }
  };

  useEffect(() => {
    fetchBooks();
    fetchRequests();
  }, []);

  const filteredBooks = books.filter((b) =>
    b.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleCreateBook = async (data) => {
    try {
      const res = await api.post("/books", data);
      setBooks((prev) => [...prev, res.data.book]);
      setShowAddModal(false);
    } catch (err) {
      console.error(err);
      alert("Error creating book");
    }
  };

  return (
    <div className="home-page">

      {/* HEADER WITH GRADIENT */}
      <header className="home-header">
        <div>
          <h1 className="app-title">Cashify</h1>
          {user && (
            <p className="welcome-text">Welcome, {user.name || user.email}</p>
          )}
        </div>

        {/* Bell icon */}
        <div className="home-bell" onClick={() => navigate("/requests")}>
          <i className="bi bi-bell-fill"></i>

          {requests > 0 && (
            <span className="home-badge">{requests}</span>
          )}
        </div>
      </header>

      {/* SEARCH BAR */}
      <div className="home-search-container">
        <i className="bi bi-search search-icon"></i>
        <input
          className="home-search"
          placeholder="Search books..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* BOOK LIST */}
      <div className="home-content">
        {loading ? (
          <div className="centered muted">Loading books...</div>
        ) : filteredBooks.length === 0 ? (
          <div className="centered muted">No books found</div>
        ) : (
          <div className="home-book-list">
            {filteredBooks.map((book) => (
              <div
                key={book._id}
                className="home-book-card"
                onClick={() => navigate(`/books/${book._id}`)}
              >
                <div className="book-info">
                  <h4 className="book-title">{book.name}</h4>
                  <p className="book-subtitle">Tap to open</p>
                </div>

                <div className="book-icon-box">
                  <i className="bi bi-journal-text book-icon"></i>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Floating Add Button */}
      <button className="home-fab " onClick={() => setShowAddModal(true)}>
        <i className="bi bi-plus-lg"></i>
      </button>

      <BottomNav />

      {showAddModal && (
        <AddBookModal
          onClose={() => setShowAddModal(false)}
          onCreate={handleCreateBook}
        />
      )}

    </div>
);

};

export default Home;
